import { render, staticRenderFns } from "./WorkFlowHeader.vue?vue&type=template&id=72e5ac09&scoped=true"
import script from "./WorkFlowHeader.vue?vue&type=script&lang=js"
export * from "./WorkFlowHeader.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowHeader.vue?vue&type=style&index=0&id=72e5ac09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e5ac09",
  null
  
)

export default component.exports